export default import.meta.ROLLUP_FILE_URL_sgevQHA$9rrkn3nu49HsPg;